import React, { useContext } from "react";
import "../style/Home.css";
import "../style/ReportCard.css";
import { Accordion, Card, Form } from "react-bootstrap";
import { deleteUser, updateUser } from "../Services/ReportingService.js";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { NotificationsContext } from "../Contexts/NotificationsContext";
import RowCard from "../Components/RowCard.js";
import DynamicTable from "../Components/DynamicTable.js";

const BundlesList = ({ props }) => {
  const { addNotification } = useContext(NotificationsContext);

  const filteredUserBundleLicensesByCompanyList = props.userBundleLicensesByCompanyLists[0]
    ? props.userBundleLicensesByCompanyLists[0].filter((license) => {
        if (props.isHomeOffice) {
          return props.companyToBusinessUnitMap.get(license.companyName) === props.list.businessUnitName;
        } else {
          return props.companyToBusinessUnitMap.get(license.companyName) === props.businessUnit;
        }
      })
    : [];

  const onItaasLevelClick = async (value, person) => {
    if (props.adminAccess) {
      let newBundleId = props.licenseBundles.find(
        (bundle) => bundle.bundleName === value && bundle.iTaaS === true
      ).bundleId;
      person.itaasPackageId = newBundleId;

      try {
        await updateUser(person);
        addNotification({ show: true, type: "Success", description: "Updated ITaaS Level Successfully" });
      } catch (error) {
        console.error(error);
        addNotification({
          show: true,
          type: "Error",
          description: (
            <>
              Updating ITaaS Level Failed. Please contact
              <b>itsupport@gocitywide.com</b> for assistance.
            </>
          ),
        });
      }
    }
  };

  const determineAndDisplayUserItaasLevel = (user) => {
    let itaasBundleName = "";
    let seconditaasBundleName = "";
    let thirditaasBundleName = "";
    if (props.licenseBundles.find((license) => license.bundleId === user.itaasPackageId)) {
      itaasBundleName = props.licenseBundles.find((license) => license.bundleId === user.itaasPackageId).bundleName;
      if (itaasBundleName === "None") {
        seconditaasBundleName = "Standard";
        thirditaasBundleName = "Premium";
      } else if (itaasBundleName === "Standard") {
        seconditaasBundleName = "None";
        thirditaasBundleName = "Premium";
      } else {
        seconditaasBundleName = "None";
        thirditaasBundleName = "Standard";
      }
    } else {
      itaasBundleName = "None";
      seconditaasBundleName = "Standard";
      thirditaasBundleName = "Premium";
    }

    return (
      <Form>
        <Form.Group controlId="showItaasLevel">
          <Form.Select custom onChange={(value) => onItaasLevelClick(value.target.value, user)}>
            <option>{itaasBundleName}</option>
            <option>{seconditaasBundleName}</option>
            <option>{thirditaasBundleName}</option>
          </Form.Select>
        </Form.Group>
      </Form>
    );
  };

  const getBundlePriceForCurrentBu = (bu) => {
    let totalPrice = 0;
    props.licenseBundles.forEach((bundle) => {
      if (bundle.iTaaS === false) {
        totalPrice +=
          props.userBundleLicensesByCompanyLists[0]
            .filter((license) => props.companyToBusinessUnitMap.get(license.companyName) === bu.businessUnitName)
            .filter((license) => license.licenseBundleId === bundle.bundleId).length * bundle.bundlePrice;
      }
    });
    return totalPrice;
  };

  const getBundlePriceForCurrentBuNonHomeOffice = (users) => {
    let totalPrice = 0;
    props.licenseBundles.forEach((bundle) => {
      if (bundle.iTaaS === false) {
        totalPrice += users.filter((user) => user.LicenseBundleId === bundle.bundleId).length * bundle.bundlePrice;
      }
    });
    return totalPrice;
  };

  const getNumberOfItaasUsersForBu = (bu) => {
    let standardItaasBundleGuid = props.licenseBundles.find(
      (license) => license.iTaaS === true && license.bundleName === "Standard"
    ).bundleId;
    let premiumItaasBundleGuid = props.licenseBundles.find(
      (license) => license.iTaaS === true && license.bundleName === "Premium"
    ).bundleId;

    return props.userBundleLicensesByCompanyLists[0]
      .filter((license) => props.companyToBusinessUnitMap.get(license.companyName) === bu.businessUnitName)
      .filter(
        (license) =>
          license.itaasPackageId === standardItaasBundleGuid || license.itaasPackageId === premiumItaasBundleGuid
      ).length;
  };

  const getNumberOfItaasUSerForBuNonHomeOffice = (users) => {
    let standardItaasBundleGuid = props.licenseBundles.find(
      (license) => license.iTaaS === true && license.bundleName === "Standard"
    ).bundleId;
    let premiumItaasBundleGuid = props.licenseBundles.find(
      (license) => license.iTaaS === true && license.bundleName === "Premium"
    ).bundleId;

    return users.filter(
      (user) => user.itaasPackageId === standardItaasBundleGuid || user.itaasPackageId === premiumItaasBundleGuid
    ).length;
  };

  const getItaasBundlesTotalPriceForBu = (bu) => {
    let standardItaasBundle = props.licenseBundles.find(
      (license) => license.iTaaS === true && license.bundleName === "Standard"
    );
    let premiumItaasBundle = props.licenseBundles.find(
      (license) => license.iTaaS === true && license.bundleName === "Premium"
    );
    let itaasBundlesTotalPrice = 0;

    itaasBundlesTotalPrice +=
      props.userBundleLicensesByCompanyLists[0]
        .filter((license) => props.companyToBusinessUnitMap.get(license.CompanyName) === bu.businessUnitName)
        .filter((license) => license.itaasPackageId === standardItaasBundle.bundleId).length *
      standardItaasBundle.bundlePrice;
    itaasBundlesTotalPrice +=
      props.userBundleLicensesByCompanyLists[0]
        .filter((license) => props.companyToBusinessUnitMap.get(license.CompanyName) === bu.businessUnitName)
        .filter((license) => license.itaasPackageId === premiumItaasBundle.bundleId).length *
      premiumItaasBundle.bundlePrice;

    return itaasBundlesTotalPrice;
  };

  const getItaasBundlesTotalPriceForBuNonHomeOffice = (users) => {
    let standardItaasBundle = props.licenseBundles.find(
      (license) => license.iTaaS === true && license.bundleName === "Standard"
    );
    let premiumItaasBundle = props.licenseBundles.find(
      (license) => license.iTaaS === true && license.bundleName === "Premium"
    );
    let itaasBundlesTotalPrice = 0;

    itaasBundlesTotalPrice +=
      users.filter((user) => user.ItaasPackageId === standardItaasBundle.bundleId).length *
      standardItaasBundle.bundlePrice;
    itaasBundlesTotalPrice +=
      users.filter((user) => user.ItaasPackageId === premiumItaasBundle.bundleId).length *
      premiumItaasBundle.bundlePrice;

    return itaasBundlesTotalPrice;
  };

  const determineItaasLevelPrice = (user) => {
    let itaasBundle = props.licenseBundles.find((license) => license.bundleId === user.itaasPackageId);
    if (!props.licenseBundles.find((license) => license.bundleId === user.itaasPackageId)) return 0;
    else return itaasBundle.bundlePrice;
  };

  const handleCityViewChange = async (obj, bundleName, person) => {
    const cityViewSelectValue = obj.target.value === "Yes" ? true : false;
    let newPerson = person;

    let bundleId = props.licenseBundles.find(
      (bundle) => bundle.bundleName === (bundleName === "Asana" ? "Asana" : "City View")
    ).bundleId;

    // Update AsanaPackageId or CityViewPackageId based on dropdown state
    if (bundleName === "Asana") {
      newPerson.AsanaPackageId = cityViewSelectValue ? bundleId : "00000000-0000-0000-0000-000000000000";
    } else if (bundleName === "City View") {
      newPerson.CityViewPackageId = cityViewSelectValue ? bundleId : "00000000-0000-0000-0000-000000000000";
    }

    try {
      await updateUser(newPerson);
      addNotification({ show: true, type: "Success", description: "Updated City View Successfully" });
    } catch (error) {
      console.error(error);
      addNotification({
        show: true,
        type: "Error",
        description: (
          <>
            Updating City View Failed. Please contact
            <b>itsupport@gocitywide.com</b> for assistance.
          </>
        ),
      });
    }
  };

  const handleAsanaChange = async (type, person) => {
    let newBundleId = "00000000-0000-0000-0000-000000000000";
    let newPerson = person;

    if (type.includes("Employee")) {
      newBundleId = props.asanaEmpBundleId;
    } else if (type.includes("Owner")) {
      newBundleId = props.asanaOwnerBundleId;
    }

    newPerson.asanaPackageId = newBundleId;
    try {
      await updateUser(newPerson);
      addNotification({ show: true, type: "Success", description: "Updated Asana Successfully" });
    } catch (error) {
      console.error(error);
      addNotification({
        show: true,
        type: "Error",
        description: (
          <>
            Updating Asana Failed. Please contact
            <b>itsupport@gocitywide.com</b> for assistance.
          </>
        ),
      });
    }
  };

  const determineAndDisplayAsanaBundleLevel = (person) => {
    if (person.asanaPackageId === props.asanaEmpBundleId) {
      return `Employee - $${props.asanaEmpBundlePrice}`;
    }
    if (person.asanaPackageId === props.asanaOwnerBundleId) {
      return "Owner - $0";
    }
    return "None";
  };

  const determineAndDisplayCityViewSelection = (person) => {
    return person.cityViewPackageId === props.cityViewBundleId ? "Yes" : "No";
  };

  const updateUserOnChange = async (value, user) => {
    if (value === "Delete User") {
      deleteUser(user).catch((err) => {
        alert("Error occured while attempting to delete user: " + err.message);
      });
    } else {
      user.licenseBundleId = props.licenseBundles.find((license) => license.bundleName === value).bundleId;
      try {
        await updateUser(user);
        addNotification({ show: true, type: "Success", description: "Updated User Successfully" });
      } catch (error) {
        console.error(error);
        addNotification({
          show: true,
          type: "Error",
          description: (
            <>
              Updating User Failed. Please contact
              <b>itsupport@gocitywide.com</b> for assistance.
            </>
          ),
        });
      }
    }
  };

  const currencyFormatter = (value, options) => {
    const defaultOptions = {
      significantDigits: 2,
      thousandsSeparator: ",",
      decimalSeparator: ".",
      symbol: "$",
    };

    if (typeof value !== "number") value = 0.0;
    options = { ...defaultOptions, ...options };
    value = value.toFixed(options.significantDigits);

    const [currency, decimal] = value.split(".");
    return `${options.symbol}${currency.replace(/\B(?=(\d{3})+(?!\d))/g, options.thousandsSeparator)}${
      options.decimalSeparator
    }${decimal}`;
  };

  const tableColumns = filteredUserBundleLicensesByCompanyList.map((employee) => {
    return (
      <>
        <td
          className="col-sm-3"
          style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", paddingLeft: "5px" }}
        >
          <div>{employee.fullName}</div>
          <div style={{ whiteSpace: "nowrap", color: "gray" }}>{employee.domainName}</div>
        </td>
        {props.licenseBundles.find((bundle) => bundle.bundleId === employee.licenseBundleId) && (
          <td
            className="col-sm-2"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              paddingLeft: "5px",
            }}
          >
            <div>{props.licenseBundles.find((bundle) => bundle.bundleId === employee.licenseBundleId).bundleName}</div>
            <div style={{ color: "gray" }}>
              {currencyFormatter(
                props.licenseBundles.find((bundle) => bundle.bundleId === employee.licenseBundleId).bundlePrice
              )}
            </div>
          </td>
        )}
        {props.adminAccess && (
          <td className="col-sm" style={{ marginRight: "10px", marginLeft: "10px" }}>
            <Form>
              <Form.Group controlId="updateUserSelect">
                <Form.Select custom onChange={(value) => updateUserOnChange(value.target.value, employee)}>
                  {props.licenseBundles.find((license) => license.bundleId === employee.licenseBundleId) && (
                    <option>
                      {props.licenseBundles.find((license) => license.bundleId === employee.licenseBundleId).bundleName}
                    </option>
                  )}
                  <option>Accounting</option>
                  <option>Operations</option>
                  <option>Sales</option>
                  <option>Executive</option>
                  <option>Email Only</option>
                  <option>Night Manager</option>
                  <option>Administrative User</option>
                  <option>CRM - Multi-Franchise</option>
                  <option>Delete User</option>
                </Form.Select>
              </Form.Group>
            </Form>
          </td>
        )}
        {props.adminAccess && (
          <td className="col-sm" style={{ marginRight: "10px", marginLeft: "10px" }}>
            {determineAndDisplayUserItaasLevel(employee)}
          </td>
        )}
        {!props.adminAccess && props.licenseBundles.find((license) => license.bundleId === employee.itaasPackageId) && (
          <td className="col-sm">
            {props.licenseBundles.find((license) => license.bundleId === employee.itaasPackageId).bundleName}
          </td>
        )}
        {
          <td className={props.isHomeOffice ? "col-sm-1" : "col-sm-2"}>
            {currencyFormatter(determineItaasLevelPrice(employee))}
          </td>
        }
        {props.isHomeOffice && (
          <td
            className="col-sm"
            style={{
              textAlign: "center",
              verticalAlign: "middle",
              marginLeft: "10px",
            }}
          >
            <Form>
              <Form.Group controlId="updateUserSelect">
                <Form.Select custom onChange={(value) => handleAsanaChange(value.target.value, employee)}>
                  <option>{determineAndDisplayAsanaBundleLevel(employee)}</option>
                  <option>None</option>
                  <option>Employee - ${props.asanaEmpBundlePrice}</option>
                  <option>Owner - $0</option>
                </Form.Select>
              </Form.Group>
            </Form>
          </td>
        )}
        {props.turnOnCityView && (
          <td
            className="col-sm"
            style={{
              textAlign: "center",
              verticalAlign: "middle",
            }}
          >
            <Form>
              <Form.Group controlId="updateUserSelect">
                <Form.Select
                  custom
                  disabled={!props.adminAccess}
                  onChange={(obj) => handleCityViewChange(obj, "City View", employee)}
                >
                  <option>{determineAndDisplayCityViewSelection(employee)}</option>
                  <option>Yes</option>
                  <option>No</option>
                </Form.Select>
              </Form.Group>
            </Form>
          </td>
        )}
      </>
    );
  });

  const renderHeaderRow = () => {
    return (
      <>
        <td className="col-sm-3">Employee Info</td>
        <td className="col-sm-2">Bundle Info</td>
        {props.adminAccess && (
          <td className="col-sm" style={{ marginRight: "10px", marginLeft: "10px" }}>
            Update User
          </td>
        )}
        <td className="col-sm" style={{ marginRight: "10px", marginLeft: "10px" }}>
          ITaaS Level
          {
            <div style={{ display: "inline-block", paddingLeft: "5px" }}>
              <button type="button" className="tooltip-image-btn" id="opsBuildingCountToolTipButton">
                <InfoOutlinedIcon fontSize="small" sx={{ color: "#2d2926" }} />
              </button>
            </div>
          }
        </td>
        <td className={props.isHomeOffice ? "col-sm-1" : "col-sm-2"}>ITaaS Price</td>
        {props.isHomeOffice && (
          <td className="col-sm" style={{ textAlign: "center" }}>
            Asana
          </td>
        )}
        {props.turnOnCityView && (
          <td className="col-sm" style={{ textAlign: "center" }}>
            City View
          </td>
        )}
      </>
    );
  };

  return (
    <div>
      <Card className={"header-card " + (props.isLastList ? "" : "pb-2")}>
        <Accordion.Item
          id="accordionButton"
          eventKey={props.isHomeOffice ? props.list.companyNumber : props.businessUnit}
          className="base-accordion"
        >
          <Accordion.Header as={Card.Header} className="p-0 rounded">
            <RowCard
              mode="grid"
              data={
                props.isHomeOffice
                  ? [
                      <div style={{ width: "90%", paddingLeft: 16 }}>Business Unit: {props.list.businessUnitName}</div>,
                      `Users: ${filteredUserBundleLicensesByCompanyList.length}`,
                      `Price: ${currencyFormatter(getBundlePriceForCurrentBu(props.list))}`,
                      `ITaaS Users: ${getNumberOfItaasUsersForBu(props.list)}`,
                      `ITaaS Price: ${currencyFormatter(getItaasBundlesTotalPriceForBu(props.list))}`,
                    ]
                  : [
                      <div style={{ width: "90%", paddingLeft: 16 }}>Business Unit: {props.businessUnit}</div>,
                      `Users: ${filteredUserBundleLicensesByCompanyList.length}`,
                      `Price: ${currencyFormatter(
                        getBundlePriceForCurrentBuNonHomeOffice(filteredUserBundleLicensesByCompanyList)
                      )}`,
                      `ITaaS Users: ${getNumberOfItaasUSerForBuNonHomeOffice(filteredUserBundleLicensesByCompanyList)}`,
                      `ITaaS Price: ${currencyFormatter(
                        getItaasBundlesTotalPriceForBuNonHomeOffice(filteredUserBundleLicensesByCompanyList)
                      )}`,
                    ]
              }
              columnWidths={["25%", "15%", "20%", "20%", "20%"]}
              padding="5px"
            />
          </Accordion.Header>
          <Accordion.Collapse
            eventKey={props.isHomeOffice ? props.list.companyNumber : props.businessUnit}
            style={{ padding: "0px 20px 20px 20px" }}
          >
            <DynamicTable header={renderHeaderRow()} rows={tableColumns} />
          </Accordion.Collapse>
        </Accordion.Item>
      </Card>
    </div>
  );
};

export default BundlesList;
